import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79ecd4fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0px 0px 20px 20px"} }, "价格表中的列将按照如下排序显示", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "请选择可以查看在《结算价管理》目录查看当前表格的用户", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_price_table_form = _resolveComponent("price-table-form")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!
  const _component_price_table_column_crud = _resolveComponent("price-table-column-crud")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(_component_miezz_page_list, {
      modelValue: _ctx.list,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.list) = $event)),
      onHandleGet: _ctx.handleGet,
      onHandleTopButtonClick: _ctx.handleTopButtonClick,
      onHandleBottomButtonClick: _ctx.handleBottomButtonClick,
      onHandleDragSort: _ctx.handleDragSort,
      leftHeaderWidth: "100%",
      class: "price-table-list"
    }, {
      "dynamic-search-customize": _withCtx(({ model }) => [
        (model.Where.Prop == 'DynamicSearch_ShowRange')
          ? (_openBlock(), _createBlock(_component_miezz_select, {
              key: 0,
              modelValue: model.Where.Value,
              "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
              options: _ctx.EnumPriceTableShowRangeOption,
              clearable: false,
              number: true
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
          : _createCommentVNode("", true)
      ]),
      "card-top": _withCtx(({ row }) => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rowButtons, (item, i) => {
          return (_openBlock(), _createBlock(_component_miezz_button, {
            key: i,
            model: item,
            onHandleClick: (arg1, arg2) => _ctx.handleRowButtonClick(arg1, row, arg2)
          }, null, 8, ["model", "onHandleClick"]))
        }), 128))
      ]),
      "card-footer": _withCtx(({ row }) => [
        _createVNode(_component_miezz_button, {
          model: _ctx.detailBtn,
          onHandleClick: (arg1, arg2) => _ctx.handleRowButtonClick(arg1, row, arg2)
        }, null, 8, ["model", "onHandleClick"])
      ]),
      column: _withCtx(({ model, row }) => [
        (model.Prop == 'OpenService')
          ? (_openBlock(), _createBlock(_component_el_switch, {
              key: 0,
              modelValue: row.OpenService,
              "onUpdate:modelValue": ($event: any) => ((row.OpenService) = $event),
              onChange: ($event: any) => (_ctx.handleOpen(row))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
          : _createCommentVNode("", true),
        (model.Prop == 'OpenSettlement')
          ? (_openBlock(), _createBlock(_component_el_switch, {
              key: 1,
              modelValue: row.OpenSettlement,
              "onUpdate:modelValue": ($event: any) => ((row.OpenSettlement) = $event),
              onChange: ($event: any) => (_ctx.handleOpen(row))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
          : _createCommentVNode("", true),
        (model.Prop == 'OpenGuide')
          ? (_openBlock(), _createBlock(_component_el_switch, {
              key: 2,
              modelValue: row.OpenGuide,
              "onUpdate:modelValue": ($event: any) => ((row.OpenGuide) = $event),
              onChange: ($event: any) => (_ctx.handleOpen(row))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
          : _createCommentVNode("", true),
        (model.Prop == 'OpenAgreement')
          ? (_openBlock(), _createBlock(_component_el_switch, {
              key: 3,
              modelValue: row.OpenAgreement,
              "onUpdate:modelValue": ($event: any) => ((row.OpenAgreement) = $event),
              onChange: ($event: any) => (_ctx.handleOpen(row))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
          : _createCommentVNode("", true),
        (model.Prop == 'OpenCost')
          ? (_openBlock(), _createBlock(_component_el_switch, {
              key: 4,
              modelValue: row.OpenCost,
              "onUpdate:modelValue": ($event: any) => ((row.OpenCost) = $event),
              onChange: ($event: any) => (_ctx.handleOpen(row))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onHandleGet", "onHandleTopButtonClick", "onHandleBottomButtonClick", "onHandleDragSort"])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalForm,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalForm) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_price_table_form, {
          modelValue: _ctx.modalForm,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalForm) = $event)),
          id: _ctx.id,
          copyId: _ctx.copyId,
          onHandleSubmit: _ctx.handleSubmit
        }, null, 8, ["modelValue", "id", "copyId", "onHandleSubmit"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalSetting,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalSetting) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_price_table_column_crud, {
          modelValue: _ctx.modalSetting,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalSetting) = $event)),
          tableId: _ctx.id,
          write: true
        }, null, 8, ["modelValue", "tableId"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalShowPower,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modalShowPower) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "show-power-form",
          model: _ctx.modalShowPowerForm,
          rules: _ctx.modalShowPowerFormRule,
          "label-width": "150px",
          inline: false
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createVNode(_component_el_form_item, { prop: "Ids" }, {
              label: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.modalShowPowerForm.CheckAll,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modalShowPowerForm.CheckAll) = $event)),
                  indeterminate: _ctx.modalShowPowerForm.CheckAllIndeterminate,
                  onChange: _ctx.handleShowPowerCheckAll
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 全部 ")
                  ]),
                  _: 1
                }, 8, ["modelValue", "indeterminate", "onChange"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: _ctx.modalShowPowerForm.Ids,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modalShowPowerForm.Ids) = $event)),
                  onChange: _ctx.handleShowPowerCheck
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users?.filter((it) => it.Value != _ctx.list.Dto?.UserId), (item) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        key: item.Value,
                        label: item.Value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.Label), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}